export default {
  title: 'Calcolatore ricavi commissione servizio',
  description: 'Stima quanto genera la commissione di servizio ogni mese. I valori si aggiornano mentre digiti.',
  authoritative:
    "La percentuale e la commissione massima qui sotto sono le impostazioni che verranno applicate. Il valore medio dell'ordine e il GMV mensile sono solo stime.",
  off_notice:
    'La commissione di servizio è disattivata in questo ristorante, quindi per ora non genera ricavi. Salva una commissione superiore a zero per attivarla.',
  fields: {
    recommended: 'Consigliato: {{value}}',
    aov: {
      label: "Valore medio dell'ordine",
      help: 'Dimensione tipica del carrello sul tuo sistema di ordini online.',
      placeholder: 'es. 32,50',
    },
    percentage: {
      label: 'Percentuale commissione di servizio',
      help: 'Tra {{min}}% e {{max}}%.',
    },
    max_amount: {
      label: 'Commissione massima per ordine',
      help: '{{max}} è il massimo consentito dalla piattaforma.',
      below_min: 'La commissione massima deve essere almeno {{min}}.',
    },
    monthly_gmv: {
      label: 'GMV mensile',
      help: 'Valore totale degli ordini elaborati al mese.',
      placeholder: 'es. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Il tuo ricavo mensile stimato',
    approximate: 'Cifra approssimativa basata sui valori sopra: il ricavo effettivo potrà variare.',
    estimate_inputs: 'Basato sul valore ordine e sul GMV stimati: il ricavo effettivo potrà variare.',
    share: 'Questa è la tua quota del {{share}}% sulla commissione di servizio totale raccolta.',
    total_collected: 'Commissione di servizio totale raccolta dagli ospiti al checkout',
    total_collected_note: '— pagata dagli ospiti, non un ricavo aggiuntivo rispetto alla cifra sopra.',
    effective_rate: 'Aliquota effettiva della commissione su tutti gli ordini',
  },
};
